<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/automationer">Visa alla automationer</router-link>
        <!--<router-link tag="li" to="/automationer/ny">Skapa ny automation</router-link>-->
      </ul>
      <div class="clear"></div>
    </div>
        
    <div v-if="triggers.length">
      <table>
        <thead>
          <tr>
            <th>Namn</th>
            <th align="right"></th>
            <th width="30" align="right">Aktiverad</th>
          </tr>
        </thead>
        
        <tbody>
          <tr v-for="trigger in triggers" :class="{ disabled: !trigger.enabled }">
            <td @click="edit(trigger)" width="300">{{ trigger.name || 'Inget namn' }}</td>
            <td align="right" v-if="trigger.enabled">
              <span v-if="trigger.id in running && running[trigger.id]"><half-circle-spinner :animation-duration="1000" :size="20" color="#033873" /></span>
              <span v-else>Vilar</span>
            </td>
            <td align="right" v-if="!trigger.enabled"></td>
            <td align="right">
              <input type="checkbox" v-model="trigger.enabled" @change="toggleEnable(trigger)">
            </td>
          </tr>
        </tbody>
      </table>
      
      <p class="descr"><strong>Tips!</strong> du kan trycka på en automation för att redigera den. Du kommer att se om automationen körs genom att det kommer en liten indikatorn bredvid den.</p>
    </div>
    <div v-else>
      <info-view>
        <img src="../assets/nexa/automationer_svart.png" style="margin-bottom:1em;">
        <h3>Inga automationer</h3>
        <p>En automation låter dig utföra kommandon när något händer i ditt hem. Ett bra exempel på detta kan vara att tända en lampa varje gång en dörr öppnas eller släcka en lampa när ingen har befunnit sig i rummet på ett tag.</p>
        <p>
          <i>Observera att automationer endast kan skapas i iOS och Android-appen.</i>
        </p>
      </info-view>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js'
  import { HalfCircleSpinner } from 'epic-spinners'
  import infoView from './views/infoView'

  export default {
    name: 'automationer',
    components: {
      HalfCircleSpinner,
      infoView
    },
    data: () => ({
      running: {}
    }),
    created () {
      // Håller koll på en automation när den körs 
      // och markerar då att automationen körs.
      eventbus.$on('scenario', (json) => {
        if (json.action === 'Started') {
          this.$set(this.running, json.causeTrigger, true)
        } else if (json.action === 'Finished') {
          if (json.causeTrigger !== 0) {
            setTimeout(() => {
              this.$set(this.running, json.causeTrigger, false)
            }, 500)
          }
        }
      })
    },
    methods: {
      toggleEnable (trigger) {
        trigger.saving = true
        HTTP.post('triggers/' + trigger.id, trigger)
        .then(res => res.data)
        .then(json => {
          trigger.saving = false
        })
      },
      
      edit (trigger) {
        this.$router.push({
          name: 'automationer_edit',
          params: {
            id: trigger.id
          }
        })
      },
      
      add () {
        this.$router.push({
          name: 'automationer_ny'
        })
      }
    },
    computed: {
      triggers: {
        get () {
          return this.$root.data.triggers.filter(trigger => trigger.triggerType === 'MongoTrigger').map(trigger => {
            trigger.running = false
            trigger.saving = false
            return trigger
          })
        },
        
        set (v) {
          alert(v)
        }
      }
    },
    destroyed () {}
  }
</script>

<style>
  .disabled {
    color:#d2d2d2;
    text-decoration: line-through;
  }
  
  .descr {
    font-size:13px;
  }
</style>


// WEBPACK FOOTER //
// src/components/automationer.vue